import {mapGetters} from 'vuex'

const CanIDo = {
  computed: {
    ...mapGetters('currentuser', {
      _currentUserObj: 'currentUserObj'
    }),
  },

  methods:{
    canIDo(...args){
      return this._currentUserObj.data && this._currentUserObj.data.id && this._currentUserObj.can(...args)
    }
  }
}

export default CanIDo

// Example of usage in a component
// 
// export default {
//   name: 'ComponentName',  
//   mixins: [CanIDo],
//   asyncComputed: {
//     canEdit(){
//       return this.canIDo('admin', 'list');
//     },
//   },
// }